export enum AppRoutes {
	ROOT = '/',
	DASHBOARD = '/dashboard',
	PERKS = '/dashboard/perks',
	OUTSOURCING = '/dashboard/outsourcing',
	COMPANY_PROFILE = '/dashboard/company/profile',
	COMPANY_PROFILE_2 = '/company/profile',
	COMPANY_PROFILE_ID = '/dashboard/company/:companyId',
	JOBS_DASHBOARD = '/dashboard/jobs',
	JOB_BOARD = '/dashboard/job-board',
	JOB_BOARD_2 = '/dashboard/candidates/track',
	CANDIDATES_DASHBOARD = '/dashboard/candidates',
	CANDIDATES_DASHBOARD_2 = '/dashboard/candidates/list',
	OFFERS_DASHBOARD = '/dashboard/offers',
	JOB_PROFILE = '/dashboard/job/:jobId',
	JOB_EDIT = '/dashboard/job/:jobId/edit',
	PAYMENT_DETAILS = '/dashboard/payment-details',
	FAQ_DASHBOARD = '/dashboard/FAQ',
	ADD_JOB = '/dashboard/add-job',
	EDIT_USER_PROFILE = '/dashboard/profile/edit',
	EDIT_USER_PROFILE_2 = '/profile/edit',
	TEAM_MEMBERS = '/dashboard/company/team',
	EDIT_COMPANY_PROFILE = '/dashboard/company/profile/edit/:companyId',
	EDIT_COMPANY_PROFILE_2 = '/company/profile/edit/:companyId',
	SIGNIN = '/signin',
	SIGNUP = '/signup',
	INVITATION_SIGNUP = '/signup/invitation/:invitationToken',
	SIGNIN_TEMP_ACCESS = '/signin/temp-access',
	ACCOUNT_CONFIRMATION = '/acc/confirmation',
	ACCOUNT_ACTIVATION = '/activate/:token',
	CHANGE_PASSWORD = '/change-password',
	FORGET_PASSWORD = '/forget-password',
	PASSWORD_RESET = '/password-reset',
	TERMS_OF_USE = '/terms-of-use',
	NOT_VALID_SESSION = '/not-valid-session'
}
